// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const HOME_SHOW_MORE_POSTS = "Zobraz dal\u0161\u00ed";
export const LIKES_MESSAGE = "se l\u00edb\u00ed zpr\u00e1va";
export const LIKES_PROFILE = "si p\u0159idala k obl\u00edben\u00fdm";
export const USER_JOINS_THE_GROUP = "se stala \u010dlenem skupiny";
